<template>
  <div class="IntroSlide2 lxn-w100 lxn-viewWithMaxWidth">
    <div class="IntroSlide2-d0">
      <CurveWithSvg :hideCurve="true">
        <template v-slot:svg>
          <svg class="lxn-w100 lxn-h100 lxn-display-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250"><circle cx="125" cy="125" r="125" fill="#3bb878"/><g fill="#414952"><path d="M132.87 90.1v12.7H119.8V90.1H60.9v65.96h13.8l12.58 20.25 13.8-20.25h31.54v-12.6h13.07v12.6h13.07v-26.75H145.7v-13.07H133v-13.07h13.07v13.07h12.7V90.1h-25.9z"/><path d="M158.78 129.32v26.75H145.7v-12.6h-13.07v12.6H101.1l-13.8 20.25-12.6-20.25H60.9v-32.95h84.8v6.2zm-1.52-39.22h13.07v13.07h-13.07V90.1z"/><path d="M157.26 143.12h13.07v13.07h-13.07v-13.07zm26.14 0h13.07v13.07H183.4v-13.07zm-24.62-26.87h11.55v13.07h-11.55z"/><path d="M158.78 123.12h11.55v6.2h-11.55zm11.55-19.94h13.07v13.07h-13.07v-13.07z"/><path d="M183.4 90.1h13.07v13.07H183.4V90.1zm0 26.15h13.07v13.07H183.4v-13.07z"/><path d="M183.4 123.1h13.07v6.2H183.4v-6.2z"/></g><path d="M73.8 108.58h46v9.5h-46v-9.5zm0 21.47h46v9.5h-46v-9.5z" fill="#636978"/></svg>
        </template>
      </CurveWithSvg>
    </div>
    <div :class="[$store.getters.language.font, $store.getters.language.directionClass]" class="IntroSlide2-title lxn-w100 lxn-title lxn-text-center">
      {{$store.getters.language.texts.IntroSlide2_title}}
    </div>
    <div :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="IntroSlide2-text lxn-w100 lxn-text lxn-text-justify">
      {{$store.getters.language.texts.IntroSlide2_text}}
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CurveWithSvg from '@/components/CurveWithSvg.vue'

export default {
  name: 'IntroSlide2',
  components: {
    CurveWithSvg,
  },
  data: function() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style>
  .IntroSlide2 {
    background-color: transparent;
    min-height: 300px;
  }
  .IntroSlide2-d0 {
    height: 40vh;
  }
  .IntroSlide2-title {
    margin-top: 20px;
    height: 30px;
    color: #1EA5DE;
    line-height: 30px;
  }
  .IntroSlide2-text {
    color: #53636C;
    margin-top: 20px;
  }
</style>
